import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import { FormattedMessage, useIntl } from 'react-intl';
import CatalogFilter from '../Catalog/CatalogFilter';
import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import { CcxMetricFilter, TrainingStatusFilter } from '../types/constants';

interface FiltersSidebarProps {
  ccxMetricFilter: string;
  trainingStatusFilter: string;
  setCcxMetricFilter: (value: string) => void;
  setTrainingStatusFilter: (value: string) => void;
  handleResetFilters: () => void;
  onClose: () => void;
}

const FiltersSidebar: React.FC<FiltersSidebarProps> = ({
  ccxMetricFilter,
  trainingStatusFilter,
  setCcxMetricFilter,
  setTrainingStatusFilter,
  handleResetFilters,
  onClose,
}) => {
  const intl = useIntl();
  const ccxMetricSelections = Object.values(CcxMetricFilter);
  const trainingStatusSelections = Object.values(TrainingStatusFilter);

  return (
    <Box
      width='100%'
      height='100%'
      spacingInset='400'
      backgroundColor='background-secondary'
    >
      <Row alignmentVertical='center' alignmentHorizontal='justify'>
        <Heading level={6}>
          <FormattedMessage
            id='cs_perfportal_training_filters_title'
            defaultMessage='Filter by'
          />
        </Heading>
        <Button type='icon' onClick={onClose} aria-label='Close filters'>
          <Icon tokens={closeTokens} />
        </Button>
      </Row>
      <Column spacing='medium' spacingInset='400 none none none'>
        <Box spacingInset='200 none'>
          <Column spacing='small'>
            <CatalogFilter
              filterLabel={intl.formatMessage({
                id: 'cs_perfportal_training_ccx_metric',
                defaultMessage: 'CCX metric',
              })}
              value={ccxMetricFilter}
              setValue={setCcxMetricFilter}
              selections={ccxMetricSelections}
            />
          </Column>
        </Box>
      </Column>
      <Column spacing='medium' spacingInset='400 none none none'>
        <Box spacingInset='200 none'>
          <Column spacing='small'>
            <CatalogFilter
              filterLabel={intl.formatMessage({
                id: 'cs_perfportal_training_catalog_status',
                defaultMessage: 'Status',
              })}
              value={trainingStatusFilter}
              setValue={setTrainingStatusFilter}
              selections={trainingStatusSelections}
            />
          </Column>
        </Box>
      </Column>
      <Column spacing='200'>
        <Button type='link' onClick={handleResetFilters}>
          <FormattedMessage
            id='cs_perfportal_training_filters_reset'
            defaultMessage='Reset Filters'
          />
        </Button>
      </Column>
    </Box>
  );
};

export default FiltersSidebar;
